import React from 'react';
import { Button } from '@/components/ui/Button';
import { 
  CheckCircle2, 
  XCircle, 
  RefreshCw, 
  Ban, 
  MessageSquare,
  MoreVertical,
  Paperclip
} from 'lucide-react';
import { Dropdown, DropdownItem } from "@/components/ui/Dropdown";

interface ApprovalActionBarProps {
  onApprove: () => void;
  onReject: () => void;
  onRequestChange: () => void;
  onCancel?: () => void;
  onComment?: () => void;
  onAttach?: () => void;
  isProcessing?: boolean;
}

export const ApprovalActionBar: React.FC<ApprovalActionBarProps> = ({
  onApprove,
  onReject,
  onRequestChange,
  onCancel,
  onComment,
  onAttach,
  isProcessing = false
}) => {
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-3 bg-white/80 backdrop-blur-md border border-slate-200 p-2.5 rounded-2xl z-50 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex items-center gap-2 pr-2 border-r border-slate-200">
        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-xl text-slate-500 hover:text-slate-900"
          onClick={onAttach}
          disabled={isProcessing}
        >
          <Paperclip className="w-5 h-5" />
        </Button>
        <Button 
          variant="ghost" 
          size="icon" 
          className="rounded-xl text-slate-500 hover:text-slate-900"
          onClick={onComment}
          disabled={isProcessing}
        >
          <MessageSquare className="w-5 h-5" />
        </Button>
      </div>

      <Button 
        variant="outline" 
        className="rounded-xl border-indigo-200 text-indigo-600 hover:bg-indigo-50 font-normal gap-2"
        onClick={onRequestChange}
        disabled={isProcessing}
      >
        <RefreshCw className={`w-4 h-4 ${isProcessing ? 'animate-spin' : ''}`} />
        Yêu cầu sửa
      </Button>

      <Button 
        variant="outline" 
        className="rounded-xl border-rose-200 text-rose-600 hover:bg-rose-50 font-normal gap-2"
        onClick={onReject}
        disabled={isProcessing}
      >
        <XCircle className="w-4 h-4" />
        Từ chối
      </Button>

      <Button 
        variant="primary" 
        className="rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-normal gap-2 px-6 -emerald-200"
        onClick={onApprove}
        disabled={isProcessing}
      >
        <CheckCircle2 className="w-4 h-4" />
        Phê duyệt
      </Button>

      <Dropdown
        trigger={
          <Button variant="ghost" size="icon" className="rounded-xl ml-1">
            <MoreVertical className="w-5 h-5 text-slate-400" />
          </Button>
        }
        align="right"
        className="w-48"
      >
        <DropdownItem onClick={onCancel} className="text-rose-600">
          <Ban className="w-4 h-4 mr-2" />
          Hủy yêu cầu
        </DropdownItem>
      </Dropdown>
    </div>
  );
};
